import { LEFT_NAV_INDEX } from 'constants/enums';
import {
  SUPPORT_MENU_ITEMS,
  AVATAR_MENU_ITEMS,
  DEFAULT_LOGO_REDIRECT_PATH,
  DEMO_USER,
  ON_PRODUCT_MENU_SELECT,
  ON_AVATAR_MENU_SELECT,
  ON_NAV_MENU_SELECT,
  ON_MULTI_GROUP_OPEN,
  ON_MULTI_GROUP_CHECK,
  ON_SINGLE_GROUP_OPEN,
  ON_SINGLE_GROUP_SELECT,
  ON_SINGLE_SELECT_INQUIRIES,
  ON_SINGLE_SELECT_CREATE_INVOICE,
  ON_SINGLE_SELECT_INVOICE_SEARCH,
  ON_SINGLE_GROUP_SELECT_INVOICING,
  ON_SINGLE_SELECT_RULES,
  ON_SINGLE_SELECT_REASON_CODES,
  ON_SINGLE_SELECT_CLIENTS,
  ON_SINGLE_SELECT_DOCUMENT_REFERENCES,
  USER_SET,
  TOGGLE_AUTH_MODAL_OPEN,
  ON_INITIAL_NOTIFICATIONS,
  ON_UPDATE_NOTIFICATIONS,
  ON_UNPROCESSED_NOTIFICATIONS,
  MARK_NOTIFICATIONS_READ,
  TOGGLE_HASE_USER_ACKNOWLEDGED,
  SET_NETWORK_ERROR_NOTIFICATION,
  SET_CLOSE_ANIMATION,
  SET_NOTIFICATION_VISIBLE,
  SET_OPEN_ANIMATION,
  SET_NAV_MENU_ITEMS,
  SET_ASSIGNEE_LIST,
  SET_APPEAL_STATUSES,
  SET_USER_CONFIGS,
  TOGGLE_USER_COLUMN_CONFIG_LOADING,
  TOGGLE_ASSIGNEE_LIST_LOADING,
  ON_SINGLE_SELECT_APPEAL_RESPONSES,
  ON_SINGLE_SELECT_ACTIVITY_LOG,
  ON_SINGLE_SELECT_MY_RECENT_ACTIVITIES,
} from './constants';

// The initial state of the App
const initialState = {
  // navigation
  navMenuItems: [],
  currentNavMenuIndex: 0,
  supportMenuItems: SUPPORT_MENU_ITEMS,
  avatarMenuItems: AVATAR_MENU_ITEMS,
  logoRedirect: DEFAULT_LOGO_REDIRECT_PATH,
  user: DEMO_USER,
  authModalOpen: false,
  hasUserAcknowledged: false,
  notifications: [],
  testSagaTimestamp: 0,
  openSingleGroupIndices: new Set(['0']),
  singleSelectIndex: LEFT_NAV_INDEX.CLAIMS_PREPAY,
  invoicingSelectIndex: '0|0',
  isInquiriesSelected: false,
  isCreateInvoiceSelected: false,
  isInvoiceSearchSelected: false,
  isClientInvoiceSelected: false,
  isMyRecentActivitiesSelected: false,
  isRulesSelected: false,
  isReasonCodesSelected: false,
  isDocumentReferencesSelected: false,
  isClientsSelected: false,
  isAppealResponsesSelected: false,
  isActivityLogSelected: false,
  networkErrorNotification: false,
  notificationVisible: false,
  openAnimationActive: false,
  closeAnimationActive: false,
  notificationMessage: '',
  notificationType: '',
  assigneeList: [],
  appealStatuses: [],
  userConfigs: [],
  initialRuleSearch: '',
  isUserColumnConfigLoading: false,
  isAssigneeListLoading: false,
};

function AppReducer(state = initialState, action) {
  switch (action.type) {
    case ON_PRODUCT_MENU_SELECT:
      return {
        ...state,
      };
    case ON_AVATAR_MENU_SELECT:
      return {
        ...state,
      };
    case ON_NAV_MENU_SELECT:
      return {
        ...state,
        currentNavMenuIndex: action.selectionIndex,
      };
    case ON_MULTI_GROUP_OPEN:
      return {
        ...state,
        multiSelectGroupOpenIDs: new Set([...action.state.openGroupIDs]),
      };
    case ON_MULTI_GROUP_CHECK:
      return {
        ...state,
        multiSelectGroupCheckedIDs: new Set([...action.state.selectedIDs]),
      };
    case ON_SINGLE_GROUP_OPEN:
      return {
        ...state,
        openSingleGroupIndices: new Set([...action.state.openGroupIndices]),
        isInquiriesSelected: false,
        isMyRecentActivitiesSelected: false,
      };
    case ON_SINGLE_GROUP_SELECT:
      return {
        ...state,
        singleSelectIndex: action.state.selectedIndex,
        isInquiriesSelected: false,
        isMyRecentActivitiesSelected: false,
      };
    case ON_SINGLE_SELECT_INQUIRIES:
      return {
        ...state,
        singleSelectIndex: '',
        isAppealsSelected: false,
        isInquiriesSelected: true,
        isMyRecentActivitiesSelected: false,
      };
    case ON_SINGLE_SELECT_MY_RECENT_ACTIVITIES:
      return {
        ...state,
        singleSelectIndex: '',
        isAppealsSelected: false,
        isInquiriesSelected: false,
        isMyRecentActivitiesSelected: true,
      };
    case ON_SINGLE_SELECT_CREATE_INVOICE:
      return {
        ...state,
        singleSelectIndex: '',
        invoicingSelectIndex: '',
        isCreateInvoiceSelected: true,
        isInvoiceSearchSelected: false,
      };
    case ON_SINGLE_SELECT_INVOICE_SEARCH:
      return {
        ...state,
        singleSelectIndex: '',
        invoicingSelectIndex: '',
        isInvoiceSearchSelected: true,
        isCreateInvoiceSelected: false,
      };
    case ON_SINGLE_GROUP_SELECT_INVOICING:
      return {
        ...state,
        invoicingSelectIndex: action.state.selectedIndex,
        isCreateInvoiceSelected: false,
        isInvoiceSearchSelected: false,
      };
    case ON_SINGLE_SELECT_RULES:
      return {
        ...state,
        singleSelectIndex: '',
        isRulesSelected: true,
        isReasonCodesSelected: false,
        isDocumentReferencesSelected: false,
        initialRuleSearch: '',
      };
    case ON_SINGLE_SELECT_REASON_CODES:
      return {
        ...state,
        singleSelectIndex: '',
        isRulesSelected: false,
        isReasonCodesSelected: true,
        isDocumentReferencesSelected: false,
      };
    case ON_SINGLE_SELECT_DOCUMENT_REFERENCES:
      return {
        ...state,
        singleSelectIndex: '',
        isRulesSelected: false,
        isReasonCodesSelected: false,
        isDocumentReferencesSelected: true,
      };
    case ON_SINGLE_SELECT_CLIENTS:
      return {
        ...state,
        singleSelectIndex: '',
        isClientsSelected: true,
      };
    case ON_SINGLE_SELECT_APPEAL_RESPONSES:
      return {
        ...state,
        singleSelectIndex: '',
        isAppealResponsesSelected: true,
      };
    case ON_SINGLE_SELECT_ACTIVITY_LOG:
      return {
        ...state,
        singleSelectIndex: '',
        isActivityLogSelected: true,
      };
    case SET_ASSIGNEE_LIST:
      return {
        ...state,
        assigneeList: action.state,
      };
    case SET_APPEAL_STATUSES:
      return {
        ...state,
        appealStatuses: action.data,
      };
    case SET_USER_CONFIGS:
      return {
        ...state,
        userConfigs: action.state,
      };
    case USER_SET:
      return {
        ...state,
        user: action.state,
      };
    case SET_NAV_MENU_ITEMS:
      return {
        ...state,
        navMenuItems: action.state,
      };
    case TOGGLE_AUTH_MODAL_OPEN:
      return {
        ...state,
        authModalOpen: action.state,
      };
    case ON_INITIAL_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.state,
      };
    case ON_UPDATE_NOTIFICATIONS:
      return {
        ...state,
        notification: {
          ...state.notifications,
          ...action.state,
        },
      };
    case TOGGLE_HASE_USER_ACKNOWLEDGED:
      return {
        ...state,
        hasUserAcknowledged: action.state,
      };
    // TODO: This is the same as mark notifications read right now
    // it could handle errors in the future, or we could merge the two then if it doesn't
    case ON_UNPROCESSED_NOTIFICATIONS:
      // eslint-disable-next-line no-case-declarations
      const processedIds = action.state.map((notification) => notification.notificationId);
      return {
        ...state,
        notifications: state.notifications.map((notification: any) => {
          const processedIndex = processedIds.indexOf(notification.notificationId);
          if (processedIndex !== -1) {
            return action.state[processedIndex];
          }
          return notification;
        }),
      };
    // TODO: Can this use a more efficient or concise lodash function?
    case MARK_NOTIFICATIONS_READ:
      // eslint-disable-next-line no-case-declarations
      const markedIds = action.state.map((notification) => notification.notificationId);
      return {
        ...state,
        notifications: state.notifications.map((notification: any) => {
          const markedIndex = markedIds.indexOf(notification.notificationId);
          if (markedIndex !== -1) {
            return action.state[markedIndex];
          }
          return notification;
        }),
      };
    case SET_NOTIFICATION_VISIBLE:
      return {
        ...state,
        notificationVisible: action.notificationVisible,
        notificationMessage: action.notificationMessage,
        notificationType: action.notificationType,
      };
    case SET_OPEN_ANIMATION:
      return {
        ...state,
        openAnimationActive: action.openAnimationActive,
      };
    case SET_CLOSE_ANIMATION:
      return {
        ...state,
        closeAnimationActive: action.closeAnimationActive,
      };
    case SET_NETWORK_ERROR_NOTIFICATION:
      return {
        ...state,
        networkErrorNotification: true,
      };
    case TOGGLE_USER_COLUMN_CONFIG_LOADING:
      return {
        ...state,
        isUserColumnConfigLoading: action.state,
      };
    case TOGGLE_ASSIGNEE_LIST_LOADING:
      return {
        ...state,
        isAssigneeListLoading: action.state,
      };
    default:
      return state;
  }
}

export default AppReducer;
